module.exports = __webpack_public_path__ + "media/5.94a4396f.mp3";